import { useTranslate } from '@tolgee/react'
import { CardWithAttributes, useContainerAttributesParameters } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { CardAttributesProps } from 'modules/ui/src/theme/components/card/CardAttributes'
import { IsoCodeMapping } from '../models/IsoCodeMapping.model'

interface Props {
  isoCodeMapping: IsoCodeMapping
  filter?: string
  onClickEdit?: (id: number) => void
}

export const IsoCodeMappingCard = observer((props: Props) => {
  const { t } = useTranslate()
  const { types: containerTypeParameters, heights: containerHeightParameters } =
    useContainerAttributesParameters()

  const { filter, isoCodeMapping, onClickEdit } = props
  const { id, isoCode, length, height, type, archetype, isoCodeMappingType } = isoCodeMapping

  const attributes: CardAttributesProps[] = [
    {
      label: t('length', 'Length'),
      value: length ?? t('unknown', 'Unknown'),
    },
    {
      label: t('height', 'Height'),
      value:
        height !== undefined && containerHeightParameters[height]
          ? containerHeightParameters[height].label
          : t('unknown', 'Unknown'),
    },
    {
      label: t('type', 'Type'),
      value:
        type !== undefined && containerTypeParameters[type]
          ? containerTypeParameters[type].label
          : t('unknown', 'Unknown'),
    },
    {
      label: t('archetype', 'Archetype'),
      value: archetype ?? t('notAssigned', 'Not assigned'),
    },
  ]

  const isStandard = isoCodeMappingType === 'Standard'

  const chipLabel = isStandard ? t('standard', 'Standard') : t('custom', 'Custom')
  const chipColor = isStandard ? 'secondary' : 'warning'

  return (
    <CardWithAttributes
      title={isoCode!.toUpperCase()}
      highlightedText={filter}
      attributes={attributes}
      chipLabel={chipLabel}
      chipColor={chipColor}
      onClick={() => onClickEdit?.(id!)}
    />
  )
})
